
import {Component, Vue} from 'vue-property-decorator';
import {IPage} from "@/js/page";
import {integrityApi} from "@/api/integrity";
import SetTableColumns from "@/components/SetTableColumns.vue"
import {dictApi, dictInstrumentApi, userApi} from "@/api/organization";
import baseUrl from '@/constants';
import Credit from "@/views/integrity/Credit.vue";
import ApplyDialog from "@/views/integrity/applyDialog.vue";
import PublicityDialog from "@/views/integrity/publicityDialog.vue";
import NameOneRowLen from "@/views/integrity/components/nameOneRowLen.vue";

const {regionData, CodeToText} = require("@/js/region/region");
@Component({
  name: "publicityList",
  components: {NameOneRowLen, PublicityDialog, ApplyDialog, Credit, SetTableColumns}
})
export default class Home extends Vue {
  regionData = regionData;
  CodeToText = CodeToText;
  title = "诚信计量公示列表";
  listData = [];
  listParam: IPage = {
    size: 10,
    current: 1,
  };
  listTotal = 0;
  listTotal0 = "";
  modeType = "0";
  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  tabCol = [];
  showForm = false;
  form = {
    orgName: "",  //单位名称
    typeId: "", //行业类别
    region: "", //所在区域
    userName: "",  //发起人
    mobile: "",  //联系电话
    start: "", //公示日期开始时间
    end: "", //公示日期结束时间
  } as any
  tableKey = 0;
  userData = {} as any;
  allSelected = [];
  statesList = [];  //行业类别
  tableLoading = true;
  showGenerateSpecialMark = false; // 是否展示生成承诺书按钮

  created() {
    this.userData = this.$store.state.AuthedUser;
    const route = this.$route;
    const q = JSON.parse(JSON.stringify(route.query));
    if (q.modeType) {
      this.modeType = q.modeType;
    }
    if (q.size) {
      this.listParam.size = Number(q.size);
      this.listParam.current = Number(q.current);
    }
    this.getConfig();
    this.getDict()
    this.haveRight();
  }

  activated() {
    if (this.$route.meta && !this.$route.meta.isBack) {
      this.showForm = false;
      this.reset();
    } else {
      this.list(this.modeType);
    }
  }

  haveRight(){
    const right = this.$store.state.userRights;
    right.forEach((e:any)=>{
      if(e.name == "generate-special-mark"){
        this.showGenerateSpecialMark = true;
      }
    })
  }

  getConfig() {
    userApi.getUserConfig({name: "auditPageSize"}).then(r => {
      if (r.data.result == 0) {
        const rData = r.data.data;
        if (rData) {
          this.listParam.size = Number(rData.config);
        }
        this.list("0");
        if (this.modeType == "1") {
          this.list("1");
        }
      }
    })
  }

  changeTabCol(e: any) {
    this.tabCol = e;
    this.$nextTick(() => {
      let $table = this.$refs.table as HTMLFormElement;
      if ($table) {
        $table.doLayout();
      }
      this.tableKey = Math.random();
    })
  }

  handleClick() {
    this.refresh();
  }

  indexMethod(index: any) {
    return (this.listParam.current - 1) * this.listParam.size + index + 1;
  }


  reset() {
    for (const f in this.form) {
      this.form[f] = "";
    }
    this.refresh();
  }

  refresh() {
    this.showForm = false;
    this.listParam.current = 1;
    this.list();
  }

  list(modeType: string = this.modeType) {
    this.tableClearSelect();
    const route = this.$route;
    let q = JSON.parse(JSON.stringify(route.query));
    q = Object.assign(q, {modeType: this.modeType}, this.listParam);
    for (const key in q) {
      q[key] = String(q[key]);
    }
    const params = {
      ...this.listParam,
      ...this.form,
      submitType: modeType ? modeType : this.modeType,
      state: 3
    }
    this.tableLoading = true;
    integrityApi.list(params).then(r => {
      if (r.data.result == 0) {
        const rData = r.data.data;
        if (this.modeType == modeType) {
          this.listData = rData.records;
          this.listTotal = rData.total;
        }
        if (modeType == "0") {
          this.listTotal0 = rData.total;
        }
        this.$nextTick(() => {
          let $table = this.$refs.table as HTMLFormElement;
          if ($table) {
            $table.doLayout();
          }
        })
      }
    }).finally(() => {
      this.tableLoading = false;
    })
  }

  pageSizeChange(val: number) {
    this.listParam.size = val;
    this.refresh();
    userApi.updateUserConfig({name: "auditPageSize", config: val})
  }

  pageCurrentChange(val: number) {
    this.listParam.current = val;
    this.list();
  }

  add() {
    this.$router.push("/qj/audit/detail/0/0");
  }

  memberSelect(selection: any, row: any) {
    this.allSelected = selection;
  }

  tableClearSelect() {
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    if ($table) {
      $table.clearSelection();
    }
  }

  rightBtn(type: string) {
    const dataArr = this.allSelected as any;
    if (dataArr.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    if (type == 'generate') {
      // 重新生成承诺书
      if (dataArr.length === 1) {
        this.generateFun(dataArr[0])
      } else {
        this.$confirm("检测到勾选多条数据，默认证书名称不换行，确定要批量重新生成承诺书吗?","确认操作",{type:"warning"}).then(()=>{
          this.generateSubmitBatch(dataArr.flatMap((e: any) => e.id).join(','));
        })
      }
      return;
    }
    if (dataArr.length > 1) {
      this.$message.error("只能勾选一条");
      return;
    }
    this.toDetail(dataArr[0]);
  }

  // 重新生成******************************
  generateData = {
    dialog: false,
    data: {} as any
  }
  generateFun(row: any) {
    this.generateData.data = row;
    this.generateData.dialog = true;
  }
  generateSubmit() {
    const loading = this.$loading({
      text: '正在生成,请稍后...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    integrityApi.generateSpecialMark({ids: this.generateData.data.id, wordNumber: (this.$refs.nameOneRowLen as any).getNumber()}).then((r: any) => {
      if (r.data.result === 0) {
        this.$message.success("生成成功");
        this.list();
        this.tableClearSelect()
        this.generateData.dialog = false;
      }
    }).finally(() => {
      loading.close();
    })
  }
  // 批量设置
  generateSubmitBatch(ids: string) {
    const loading = this.$loading({
      text: '正在生成,请稍后...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    integrityApi.generateSpecialMark({ids: ids, wordNumber: 100}).then((r: any) => {
      if (r.data.result === 0) {
        this.$message.success("生成成功");
        this.list();
        this.tableClearSelect()
      }
    }).finally(() => {
      loading.close();
    })
  }
  // 重新生成end******************************

  delBtn() {
    if (this.allSelected.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    const ids = this.allSelected.flatMap((e: any) => {
      return e.id
    });

    this.$confirm('此操作将删除/办结, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      integrityApi.deleteIntegrity({ids: ids.join(",")}).then((r: any) => {
        if (r.data.result == 0) {
          this.list();
        }
      });
    }).catch(() => {
      console.log("取消")
    });

  }

  baseUrl = baseUrl

  toDetail(row: any) {
    (this.$refs.publicityDialogRef as any).setData(row)
  }

  getDict() {
    return dictApi.listDictItem({
      typeCode: "hylb"
    }).then(r => {
      if (r.data.result === 0) {
        this.statesList = r.data.data;
      }
    })
  }

  downloadPdf(row: any) {
    window.open(baseUrl + "/file/download?file=" + row.promiseCreateUrl + "&name=" + row.orgName + "公示承诺书.pdf", '_blank');
  }

  rightBtnDownload(type: string) {
    const dataArr = this.allSelected as any;
    if (dataArr.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    if (type == 'download') {
      // 下载承诺书
      integrityApi.downloadPromises({ids: dataArr.flatMap((e: any) => e.id).join(',')}).then((r: any) => {
        if (r.data.result === 0) {
          window.open(baseUrl + "/file/download?file=" + r.data.data + "&name=" + "承诺书.zip", '_blank');
        }
      })
    } else if (type == 'export') {
      // 导出xlsx数据
      integrityApi.exportData({ids: dataArr.flatMap((e: any) => e.id).join(',')}).then((r: any) => {
        if (r.data.result === 0) {
          window.open(baseUrl + "/file/download?file=" + r.data.data + "&name=" + "承诺单位导出.xlsx", '_blank');
        }
      })
    }
  }
}
